'use strict';

import * as cart from '../store/cart';
import $ from 'jquery';

const { location, document } = window;

const dataTocart = element => element.dataset.tocart;
const dataApiUrl = element => element.dataset.apiUrl;

export async function addToCart(id, url) {
	return import('axios').then(({ default: axios }) => {
		const params = new URLSearchParams();

		params.append('PRODUCT_ID', id);

		const request = axios.post(url, params);

		request.catch(error => console.error(error));

		return request;
	});
}

export function changeButton(button) {
	button.classList.replace('button_theme_secondary-ghost', 'button_theme_secondary');
	button.dataset.link = ''; // legacy - style compability
	button.addEventListener('click', () => location.href = '/basket/');
	delete button.dataset.apiUrl;
	button.innerText = 'Оформить заказ';
}

async function handleClick({ currentTarget: button }) {
	const id = dataTocart(button);
	const api = dataApiUrl(button);

	button.disabled = true;

	if (!api)
		return;

	await addToCart(id, api);

	button.disabled = false;
	changeButton(button);
	cart.update();
}

document.addEventListener('DOMContentLoaded', () => {
	$(document).on('click', 'button[data-tocart]', handleClick);
});
